import bfh from 'url:../assets/goldenhorse.png';
import '../styles/bfh.css';
import tri from 'url:../assets/audio/triumph.mp3';
import { useRef } from 'react';

export function BFH() {
    const audioRef = useRef(tri);

    return <div className='bfh'>
        <audio 
            ref={audioRef} 
            src={tri} 
            autoPlay
        />

        <img src={bfh} className='spinny'/>
    </div>
}